/*
 * Action Types
 */
export enum lastVersionTypes {
  SET_LOCAL_STORAGE_VERSION = '@lastVersion/SET_LOCAL_STORAGE_VERSION',
}

/*
 * State type
 */
export interface lastVersionState {
  readonly lastVersion: string;
}
